import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=44bea1ac&scoped=true&"
import script from "./perfil.ts?vue&type=script&lang=ts&"
export * from "./perfil.ts?vue&type=script&lang=ts&"
import style0 from "./Perfil.vue?vue&type=style&index=0&id=44bea1ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bea1ac",
  null
  
)

export default component.exports